export class DateTime{
    private _day:any;
    private _month:any;
    private _year:any;
    private _hour:any;
    private _minute:any;
    private _second:any;
    private _milisecond:any;
    private _amPm:any;
    private _monthStr:any;

    months:string[]=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
    

	constructor(day?:any,month?:any,year?:any,hour?:any,minute?:any,second?:any,milisecond?:any,amPm?:any) {
        this._day = day;
        this._month = month;
        this._year = year;
        this._hour = hour;
        this._minute = minute;
        this._second = second;
        this._milisecond = milisecond;
        this._amPm = amPm;
	}

    /**
     * Getter day
     * @return {any}
     */
	public get day(): any {
		return this._day;
	}

    /**
     * Getter month
     * @return {any}
     */
	public get month(): any {
		return this._month + 1;
	}

    /**
     * Getter year
     * @return {any}
     */
	public get year(): any {
		return this._year;
	}

    /**
     * Getter hour
     * @return {any}
     */
	public get hour(): any {
		return this._hour;
	}

    /**
     * Getter minute
     * @return {any}
     */
	public get minute(): any {
		return this._minute;
	}

    /**
     * Getter second
     * @return {any}
     */
	public get second(): any {
		return this._second;
	}

    /**
     * Getter milisecond
     * @return {any}
     */
	public get milisecond(): any {
		return this._milisecond;
	}

    /**
     * Getter amPm
     * @return {any}
     */
	public get amPm(): any {
		return this._amPm;
    }
    

    /**
     * Getter monthStr
     * @return {any}
     */
	public get monthStr(): any {
        if(this._month != null){
            return this.months[this._month];
        }
		return null;
	}



}

